module.exports = __webpack_public_path__ + "images/category_lp/watch/store_images/4_5934263da031faa650530b415f087e3c.png";